var _circle, _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.9,
    r: 0.9,
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35938 18.3633C6.84375 18.3633 7.21875 18.1445 7.8125 17.6211L10.4766 15.2773H14.9375C17.3047 15.2773 18.6875 13.8711 18.6875 11.5352V5.38672C18.6875 3.05078 17.3047 1.63672 14.9375 1.63672H5.0625C2.69531 1.63672 1.3125 3.04297 1.3125 5.38672V11.5352C1.3125 13.8789 2.75781 15.2773 4.96094 15.2773H5.23438V17.1055C5.23438 17.8789 5.65625 18.3633 6.35938 18.3633ZM6.78906 16.3711V14.1758C6.78906 13.6758 6.57031 13.4961 6.10938 13.4961H5.14844C3.76562 13.4961 3.10156 12.793 3.10156 11.4414V5.47266C3.10156 4.12109 3.76562 3.42578 5.14844 3.42578H14.8516C16.2266 3.42578 16.8984 4.12109 16.8984 5.47266V11.4414C16.8984 12.793 16.2266 13.4961 14.8516 13.4961H10.3594C9.85156 13.4961 9.61719 13.582 9.25 13.9492L6.78906 16.3711Z",
    fill: "inherit"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.155,
    y: 4.64804,
    width: 1.69,
    height: 5,
    rx: 0.845,
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.559b3ddd.svg";
export { ForwardRef as ReactComponent };